module.exports = __webpack_public_path__ + "img/SKMJ_safetoollist.10578700.png";